module.exports = __webpack_public_path__ + "static/myLocationPin-f480c3d06c94233f9226f206ed9209dc.png";